namespace Gamification.Gamification {
    export interface ProdottiClassiAssetEsperienzeForm {
        UserId: Serenity.IntegerEditor;
        TenantId: Serenity.IntegerEditor;
        IdProdottoClasse: Serenity.IntegerEditor;
        IdAssetEsperienza: Serenity.IntegerEditor;
    }

    export class ProdottiClassiAssetEsperienzeForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.ProdottiClassiAssetEsperienze';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProdottiClassiAssetEsperienzeForm.init)  {
                ProdottiClassiAssetEsperienzeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;

                Q.initFormType(ProdottiClassiAssetEsperienzeForm, [
                    'UserId', w0,
                    'TenantId', w0,
                    'IdProdottoClasse', w0,
                    'IdAssetEsperienza', w0
                ]);
            }
        }
    }
}
